import axios from 'axios';
import AccessToken from '@/services/auth-central';
import signature  from '@/services/signature';

class Signature {
    create(query){
        return signature(query);
    }
}

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.API_BASE_URI;
const ZEROBOUNCE_URL = process.env.API_ZEROBOUNCE_URL;
const ZEROBOUNCE_KEY = process.env.API_ZEROBOUNCE_KEY;
const API_SETTING_GETUSER = '/v1/central/customer/getstaff';
const STORE_SEARCH = '/v2/import/xcom/tenants'
const BUYER_STORE_SEARCH = '/v2/import/buyer/tenants'
const CUSTOMER_V2_TAG = '/v2/customer/tags'
const CUSTOMER_V2_REFER = '/v2/customer/refers'
let config = {
    headers: {
        Authorization: 'Bearer ' + ACCESS_TOKEN.token
    }
};

let configZerobounce = {
    transformRequest: (data, headers) => {
        delete headers.common['Authorization'];
        return data;
    }
};

const API_TAG = '/v1/central/tag';
const API_LEADS = '/v2/lead';
const API_CUSTOMERS = '/v2/customer';
const STAFF_SEARCH = '/v1/central/tenant/search-staffs'
const COUPONOWNER_SEARCH = '/v1/central/coupon/search-couponOwner'
const IMPORT_XCOM_TENANST = '/v2/import/xcom/tenants'
const COUPON_SEARCH = '/v1/central/coupon/search-coupon'

class Auth {
    async User() {
        return await axios.get(BASE_URI + '/v1/auth/user', config);
    }
    async postUser(data) {

        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        return await axios.post(BASE_URI + '/v1/auth/user', data, addConfig);
    }
    async getAccess() {
        return await axios.get(BASE_URI + '/v1/auth/getaccess', config);
    }
    async getDevices() {
        return await axios.get(BASE_URI + '/v1/devices', config);
    }
    async getTokens() {
        return await axios.get(BASE_URI + '/v1/tokens', config);
    }
    async getUser(querystring = '') {
        return await axios.get(BASE_URI + '/v1/auth/getuser' + querystring, config);
    }
    async changepassword(data) {
        return await axios.post(BASE_URI + '/v1/auth/changepassword', data, config);
    }

    async logOut(data = []) {
        return await axios.post(BASE_URI + '/v1/auth/logout',data,config);
    }
    async sendVerify(data) {
        return await axios.post(BASE_URI + '/v1/auth/email/send', data, config);
    }
    async isBacklistEmail(data) {
        return await axios.get(BASE_URI + '/v1/auth/email/blacklist/' + data, config);
    }
    async isRegisteredEmail(data) {
        return await axios.get(BASE_URI + '/v1/auth/email/registered/' + data, config);
    }
    async getZeroBouunceEmail(data) {
        return await axios.get(BASE_URI + '/v1/auth/email/zerobounce/' + data, config);
    }
    async isUniquePhoneNumber(data) {
        return await axios.get(BASE_URI + '/v1/auth/phone/registered/' + data, config);
    }
    async forgotPassword(data) {
        return await axios.post(BASE_URI + '/v1/auth/password/forgot', data, config);
    }
    async resetPassword(data) {
        return await axios.post(BASE_URI + '/v1/auth/password/reset', data, config);
    }
}

class Tenant {
    async getStatus(tenantId) {
        return await axios.get(BASE_URI + '/v1/tenant/' + tenantId + '/getstatus', config);
    }

    async createStore(data) {
        return await axios.post(BASE_URI + '/v1/tenants', data, config);
    }

    async checkImported(tenantId) {
        return await axios.get(BASE_URI + `/v1/central/tenant/importXcom/checkImported/${tenantId}`, config);
    }

    async newSubscription(id, data) {
        return await axios.post(BASE_URI + `/v1/central/tenant/${id}/subscription`, data, config);
    }

    async renewSubscription(id, data) {
        return await axios.post(BASE_URI + `/v1/central/tenant/${id}/subscription/renew`, data, config);
    }

    async getMerchantInfo(data) {
        return await axios.get(BASE_URI + `/v1/central/merchant/getinfo` + data, config);
    }

    async setMaintenanceMode(id,data){
        return await axios.post(BASE_URI + `/v1/central/tenant/${id}/set-maintenance-mode`, data, config);
    }

    async searchTenant(query) {
        return await axios.get(BASE_URI + '/v1/central/tenant?search=' + encodeURIComponent(query) + '&per_page=20&lite=1', config);
    }
}


class Domain {
    async checkDomain(domain) {
        let querystring = '?domain='+domain;
        return await axios.get(BASE_URI + '/v1/has/domain' + querystring, config);
    }

    async getDomain(querystring) {
        return await axios.get(BASE_URI + '/v1/central/domain' + querystring, config);
    }

    async getDomainById(id) {
        return await axios.get(BASE_URI + '/v1/central/domain/' + id, config);
    }

    async confirmDomain(id, data) {
        return await axios.post(BASE_URI + '/v1/central/domain/' + id + '/confirmDomain', data, config);
    }

    async updateDomain(id, data) {
        return await axios.put(BASE_URI + '/v1/central/domain/' + id, data, config);
    }

    async disableDistribution(data) {
        return await axios.post(BASE_URI + '/v1/aws/distribution/disable', data, config);
    }

    async moveDistribution(data) {
        return await axios.post(BASE_URI + '/v1/aws/distribution/move', data, config);
    }
}

class Customer {
    async getCustomer(querystring) {
        return await axios.get(BASE_URI + '/v1/central/customer' + querystring, config);
    }

    async showCustomer(id) {
        const response = await axios.get(BASE_URI + '/v1/central/customer/'+id, config);
        return response;
    }

    async updateStatus(customer_id, data) {
        return await axios.post(BASE_URI + '/v1/central/customer/'+customer_id+'/updatestatus', data, config);
    }

    async getCustomerNoteMedia(customer_id) {
        return await axios.get(BASE_URI + '/v1/central/customer/'+customer_id+'/getNoteMedia', config);
    }

    async postAddNote(customer_id, data) {
        return await axios.post(BASE_URI + '/v1/central/customer/'+customer_id+'/addnote', data, config);
    }

    async putUpdateNote(customer_id, data) {
        return await axios.post(BASE_URI + '/v1/central/customer/'+customer_id+'/updatenote', data, config);
    }

    async deleteNote(note_id) {
        return await axios.delete(BASE_URI + '/v1/central/customer-note/'+note_id, config);
    }

    async checkPhone(mobile) {
        let querystring = '?mobile='+mobile;
        return await axios.get(BASE_URI + '/v1/has/customer' + querystring, config);
    }

    async checkEmail(data) {
        return await axios.get(BASE_URI + '/v1/central/customer/checkemail/' + data, config);
    }

    async getStaff(query) {
        return await axios.get(BASE_URI + '/v1/central/customer/getstaff'+query, config);
    }

    async postAddStaff(customer_id, data) {
        return await axios.post(BASE_URI + '/v1/central/customer/'+customer_id+'/addstaff', data, config);
    }

    async deleteStaff(customer_id, data) {
        return await axios.post(BASE_URI + '/v1/central/customer/'+customer_id+'/deletestaff', data, config);
    }

    async postAddTag(customer_id, data) {
        return await axios.post(BASE_URI + '/v1/central/customer/'+customer_id+'/addtag', data, config);
    }

    async deleteTag(tag_id) {
        return await axios.delete(BASE_URI + '/v1/central/customer-tag/'+tag_id, config);
    }

    async getCustomerTenant(customer_id, query) {
        return await axios.get(BASE_URI + '/v1/central/customer/'+customer_id+'/gettenant'+query, config);
    }

    async getCustomerLog(customer_id, query = '') {
        return await axios.get(BASE_URI + '/v1/central/customer/' + customer_id + '/getlog' + query, config);
    }
}

class CustomerV2 {
    async getCustomer(queryString = '') {
        try{
            const response = await axios.get(BASE_URI + '/v2/customer' + signature(queryString), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async getTenant(id, querystring = ''){ 
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + id + '/tenants' + signature(querystring), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }

    async getCustomerInfo(id){ 
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + id + signature(), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    
    async getCustomerLogV2(id, querystring = ''){
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + id + '/logs' + signature(querystring), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }

    async getCustomerTags(id, querystring = ''){
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + id + '/tags' + signature(querystring), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }

    async postCustomerTags(id, data){
        try{
            const response = await axios.post(BASE_URI + '/v2/customer/' + id + '/tags' + signature(), data, config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }

    async deleteCustomerTags(id, tag_id){
        try{
            const response = await axios.delete(BASE_URI + '/v2/customer/' + id + '/tags/' + tag_id + signature(), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }

    async getCustomerNotes(id, querystring = ''){
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + id + '/notes' + signature(querystring), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async getCustomerAppointments(idCustomer, querystring = ''){
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + idCustomer + '/appointments' + signature(querystring), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async postCustomerAppointments(id, data){
        try{
            const response = await axios.post(BASE_URI + '/v2/customer/' + id + '/appointments' + signature(), data, config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async getCustomerAppointmentsById(idCustomer, idAppointments){
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + idCustomer + '/appointments/'+idAppointments +'/edit'+ signature(), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async putCustomerAppointments(id,idAppointments, data){
        try{
            const response = await axios.put(BASE_URI + '/v2/customer/' + id +"/appointments/"+idAppointments + signature(), data, config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async deleteCustomerAppointments(idCustomer = '', idAppointments = ''){
        try{
            const response = await axios.delete(BASE_URI + '/v2/customer/' + idCustomer + '/appointments/' + idAppointments + signature(), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async postCustomerNotes(id, data){
        try{
            const response = await axios.post(BASE_URI + '/v2/customer/' + id + '/notes' + signature(), data, config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async editCustomerNotes(id, note_id, querystring = ''){
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + id + '/notes/'+ note_id +'/edit' + signature(querystring), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async putCustomerNotes(id, note_id, data){
        try{
            const response = await axios.put(BASE_URI + '/v2/customer/' + id + '/notes/'+ note_id + signature(), data, config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async deleteCustomerNotes(id, note_id){
        try{
            const response = await axios.delete(BASE_URI + '/v2/customer/' + id + '/notes/' + note_id + signature(), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async getCustomeProfile(id, querystring = ''){
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + id + '/profiles' + signature(querystring), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async editCustomerProfile(id, profiles_id, querystring = ''){
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + id + '/profiles/'+ profiles_id +'/edit' + signature(querystring), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async putCustomerProfile(id, profiles_id, data){
        try{
            const response = await axios.put(BASE_URI + '/v2/customer/' + id + '/profiles/'+ profiles_id + signature(), data, config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async getCustomeCallHistoryLogs(id, querystring = ''){
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + id + '/calls' + signature(querystring), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }

    async getUnsuspend(id){
        try{
            const response = await axios.get(BASE_URI + '/v2/customer/' + id + '/suspend' + signature(), config); 
            return response;
        } catch (err) { 
            return err.response;
        }
    }

    async putUnsuspendById(id,data){
        try{
            const response = await axios.put(BASE_URI + '/v2/customer/' + id + '/suspend' + signature(),data, config); 
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async putSuspendById(id , data){
        try{
            const response = await axios.put(BASE_URI + '/v2/customer/' + id + '/unsuspend' + signature(), data, config); 
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async putBlockById(id , data){
        try{
            const response = await axios.put(BASE_URI + '/v2/customer/' + id + '/block' + signature(), data, config); 
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async putUnblockById(id , data){
        try{
            const response = await axios.put(BASE_URI + '/v2/customer/' + id + '/unblock' + signature(), data, config); 
            return response;
        } catch (err) { 
            return err.response;
        }
    }
}

class Invitation {
    async getInvitationList(querystring = '') {
        return await axios.get(BASE_URI + '/v1/central/invitation' + querystring, config);
    }
    async postAcceptInvitaion(invitationId, data = {}) {
        const response = await axios.post(BASE_URI + '/v1/central/invitation/' + invitationId, data, config);
        return response;
    }
    async deleteInvitaion(invitationId) {
        const response = await axios.delete(BASE_URI + '/v1/central/invitation/' + invitationId, config);
        return response;
    }
}

class Address {
    async getAddressJson() {
        return await axios.get(BASE_URI + '/v1/address-json', config);
    }
}

class Password {
    async Timechangepassword(data) {
        return await axios.get(BASE_URI + '/v1/central/password/changepasswordat/' + data, config);
    }
    async changepassword(data) {
        return await axios.put(BASE_URI + '/v1/central/password/changepassword', data, config);
    }
}

class Email {
    async getEmailZeroBounce(data) {
        return await axios.get(ZEROBOUNCE_URL + '/v2/validate?api_key=' + ZEROBOUNCE_KEY + '&email=' + data, configZerobounce);
    }
}
class Gender {
    async getGender(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/gender'+queryString, config);
        return response;
    }

    async addGender(data) {
        const response = await axios.post(BASE_URI + '/v1/central/gender', data, config);
        return response;
    }

    async showGender(gender_id) {
        const response = await axios.get(BASE_URI + '/v1/central/gender/'+gender_id, config);
        return response;
    }

    async updateGender(data,gender_id) {
        const response = await axios.put(BASE_URI + '/v1/central/gender/'+gender_id, data,config);
        return response;
    }

    async deleteGender(gender_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/gender/'+gender_id,config);
        return response;
    }
}

class Industry {
    async getIndustry(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/industry'+queryString, config);
        return response;
    }

    async addIndustry(data) {
        const response = await axios.post(BASE_URI + '/v1/central/industry', data, config);
        return response;
    }

    async showIndustry(industry_id) {
        const response = await axios.get(BASE_URI + '/v1/central/industry/'+industry_id, config);
        return response;
    }

    async updateIndustry(data,industry_id) {
        const response = await axios.put(BASE_URI + '/v1/central/industry/'+industry_id, data,config);
        return response;
    }

    async deleteIndustry(industry_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/industry/'+industry_id,config);
        return response;
    }
}

class CustomerType {
    async getCustomerType(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/customer-type'+queryString, config);
        return response;
    }

    async addCustomerType(data) {
        const response = await axios.post(BASE_URI + '/v1/central/customer-type', data, config);
        return response;
    }

    async showCustomerType(customertype_id) {
        const response = await axios.get(BASE_URI + '/v1/central/customer-type/'+customertype_id, config);
        return response;
    }

    async updateCustomerType(data,customertype_id) {
        const response = await axios.put(BASE_URI + '/v1/central/customer-type/'+customertype_id, data,config);
        return response;
    }

    async deleteCustomerType(customertype_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/customer-type/'+customertype_id,config);
        return response;
    }
}

class Bank {
    async getBank(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/bank'+queryString, config);
        return response;
    }

    async addBank(data) {
        const response = await axios.post(BASE_URI + '/v1/central/bank', data, config);
        return response;
    }

    async showBank(bank_id) {
        const response = await axios.get(BASE_URI + '/v1/central/bank/'+bank_id, config);
        return response;
    }

    async updateBank(data,bank_id) {
        const response = await axios.post(BASE_URI + '/v1/central/bank/'+bank_id, data,config);
        return response;
    }

    async deleteBank(bank_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/bank/'+bank_id,config);
        return response;
    }
}

class Country {
    async getCountry(queryString = null) {
        const response = await axios.get(BASE_URI + '/v1/central/country'+queryString, config);
        return response;
    }

    async addCountry(data) {
        const response = await axios.post(BASE_URI + '/v1/central/country', data, config);
        return response;
    }

    async showCountry(country_id) {
        const response = await axios.get(BASE_URI + '/v1/central/country/'+country_id, config);
        return response;
    }

    async updateCountry(data,country_id) {
        const response = await axios.put(BASE_URI + '/v1/central/country/'+country_id, data,config);
        return response;
    }

    async deleteCountry(country_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/country/'+country_id,config);
        return response;
    }
}

class ShippingType {
    async getShippingType(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/shipping-type'+queryString, config);
        return response;
    }

    async addShippingType(data) {
        const response = await axios.post(BASE_URI + '/v1/central/shipping-type', data, config);
        return response;
    }

    async showShippingType(shippingtype_id) {
        const response = await axios.get(BASE_URI + '/v1/central/shipping-type/'+shippingtype_id, config);
        return response;
    }

    async updateShippingType(data,shippingtype_id) {
        const response = await axios.put(BASE_URI + '/v1/central/shipping-type/'+shippingtype_id, data,config);
        return response;
    }

    async deleteShippingType(shippingtype_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/shipping-type/'+shippingtype_id,config);
        return response;
    }
}

class SocialCodeType {
    async getSocialCodeType(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/social-code-type'+queryString, config);
        return response;
    }

    async addSocialCodeType(data) {
        const response = await axios.post(BASE_URI + '/v1/central/social-code-type', data, config);
        return response;
    }

    async showSocialCodeType(socialcodetype_id) {
        const response = await axios.get(BASE_URI + '/v1/central/social-code-type/'+socialcodetype_id, config);
        return response;
    }

    async updateSocialCodeType(data,socialcodetype_id) {
        const response = await axios.put(BASE_URI + '/v1/central/social-code-type/'+socialcodetype_id, data,config);
        return response;
    }

    async deleteSocialCodeType(socialcodetype_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/social-code-type/'+socialcodetype_id,config);
        return response;
    }
}

class PaymentMethod {
    async getPaymentMethod(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/payment-method'+queryString, config);
        return response;
    }

    async addPaymentMethod(data) {
        const response = await axios.post(BASE_URI + '/v1/central/payment-method', data, config);
        return response;
    }

    async showPaymentMethod(paymentmethod_id) {
        const response = await axios.get(BASE_URI + '/v1/central/payment-method/'+paymentmethod_id, config);
        return response;
    }

    async updatePaymentMethod(data,paymentmethod_id) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };
        const response = await axios.post(BASE_URI + '/v1/central/payment-method/'+paymentmethod_id, data,addConfig);
        return response;
    }

    async deletePaymentMethod(paymentmethod_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/payment-method/'+paymentmethod_id,config);
        return response;
    }
}

class VatMethod {
    async getVatMethod(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/vat-method'+queryString, config);
        return response;
    }

    async addVatMethod(data) {
        const response = await axios.post(BASE_URI + '/v1/central/vat-method', data, config);
        return response;
    }

    async showVatMethod(vatmethod_id) {
        const response = await axios.get(BASE_URI + '/v1/central/vat-method/'+vatmethod_id, config);
        return response;
    }

    async updateVatMethod(data,vatmethod_id) {
        const response = await axios.put(BASE_URI + '/v1/central/vat-method/'+vatmethod_id, data,config);
        return response;
    }

    async deleteVatMethod(vatmethod_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/vat-method/'+vatmethod_id,config);
        return response;
    }
}

class Unit {
    async getUnit(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/unit'+queryString, config);
        return response;
    }

    async addUnit(data) {
        const response = await axios.post(BASE_URI + '/v1/central/unit', data, config);
        return response;
    }

    async showUnit(unit_id) {
        const response = await axios.get(BASE_URI + '/v1/central/unit/'+unit_id, config);
        return response;
    }

    async updateUnit(data,unit_id) {
        const response = await axios.put(BASE_URI + '/v1/central/unit/'+unit_id, data,config);
        return response;
    }

    async deleteUnit(unit_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/unit/'+unit_id,config);
        return response;
    }
}

class ProductType {
    async getProductType(queryString = '') {
        const response = await axios.get(BASE_URI + '/v1/central/product-type'+queryString, config);
        return response;
    }

    async addProductType(data) {
        const response = await axios.post(BASE_URI + '/v1/central/product-type', data, config);
        return response;
    }

    async showProductType(producttype_id) {
        const response = await axios.get(BASE_URI + '/v1/central/product-type/'+producttype_id, config);
        return response;
    }

    async updateProductType(data,producttype_id) {
        const response = await axios.put(BASE_URI + '/v1/central/product-type/'+producttype_id, data,config);
        return response;
    }

    async deleteProductType(producttype_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/product-type/'+producttype_id,config);
        return response;
    }
}

class SalePageType {
    async getSalePageType(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/salepage-type'+queryString, config);
        return response;
    }

    async addSalePageType(data) {
        const response = await axios.post(BASE_URI + '/v1/central/salepage-type', data, config);
        return response;
    }

    async showSalePageType(salepagetype_id) {
        const response = await axios.get(BASE_URI + '/v1/central/salepage-type/'+salepagetype_id, config);
        return response;
    }

    async updateSalePageType(data,salepagetype_id) {
        const response = await axios.put(BASE_URI + '/v1/central/salepage-type/'+salepagetype_id, data,config);
        return response;
    }

    async deleteSalePageType(salepagetype_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/salepage-type/'+salepagetype_id,config);
        return response;
    }
}

class LabelType {
    async getLabelType(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/label-type'+queryString, config);
        return response;
    }

    async getLabelType(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/label-type'+queryString, config);
        return response;
    }   
    async addLabelType(data) {
        const response = await axios.post(BASE_URI + '/v1/central/label-type', data, config);
        return response;
    }

    async showLabelType(labeltype_id) {
        const response = await axios.get(BASE_URI + '/v1/central/label-type/'+labeltype_id, config);
        return response;
    }

    async updateLabelType(data,labeltype_id) {
        const response = await axios.put(BASE_URI + '/v1/central/label-type/'+labeltype_id, data,config);
        return response;
    }

    async deleteLabelType(labeltype_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/label-type/'+labeltype_id,config);
        return response;
    }
}

class IntegrationGroup {
    async getIntegrationGroup(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/integration-group'+queryString, config);
        return response;
    }

    async addIntegrationGroup(data) {
        const response = await axios.post(BASE_URI + '/v1/central/integration-group', data, config);
        return response;
    }

    async showIntegrationGroup(integrationgroup_id) {
        const response = await axios.get(BASE_URI + '/v1/central/integration-group/'+integrationgroup_id, config);
        return response;
    }

    async updateIntegrationGroup(data,integrationgroup_id) {
        const response = await axios.put(BASE_URI + '/v1/central/integration-group/'+integrationgroup_id, data,config);
        return response;
    }

    async deleteIntegrationGroup(integrationgroup_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/integration-group/'+integrationgroup_id,config);
        return response;
    }
}

class Module {
    async getModule(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/module'+queryString, config);
        return response;
    }

    async addModule(data) {
        const response = await axios.post(BASE_URI + '/v1/central/module', data, config);
        return response;
    }

    async showModule(module_id) {
        const response = await axios.get(BASE_URI + '/v1/central/module/'+module_id, config);
        return response;
    }

    async updateModule(data,module_id) {
        const response = await axios.put(BASE_URI + '/v1/central/module/'+module_id, data,config);
        return response;
    }

    async deleteModule(module_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/module/'+module_id,config);
        return response;
    }
}

class LocationType {
    async getLocationType(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/location-type'+queryString, config);
        return response;
    }

    async addLocationType(data) {
        const response = await axios.post(BASE_URI + '/v1/central/location-type', data, config);
        return response;
    }

    async showLocationType(locationtype_id) {
        const response = await axios.get(BASE_URI + '/v1/central/location-type/'+locationtype_id, config);
        return response;
    }

    async updateLocationType(data,locationtype_id) {
        const response = await axios.put(BASE_URI + '/v1/central/location-type/'+locationtype_id, data,config);
        return response;
    }

    async deleteLocationType(locationtype_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/location-type/'+locationtype_id,config);
        return response;
    }
}

class Font {
    async getFont(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/font'+queryString, config);
        return response;
    }

    async addFont(data) {
        const response = await axios.post(BASE_URI + '/v1/central/font', data, config);
        return response;
    }

    async showFont(font_id) {
        const response = await axios.get(BASE_URI + '/v1/central/font/'+font_id, config);
        return response;
    }

    async updateFont(data,font_id) {
        const response = await axios.put(BASE_URI + '/v1/central/font/'+font_id, data,config);
        return response;
    }

    async deleteFont(font_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/font/'+font_id,config);
        return response;
    }
}

class Vat {
    async getVat(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/vat'+queryString, config);
        return response;
    }

    async addVat(data) {
        const response = await axios.post(BASE_URI + '/v1/central/vat', data, config);
        return response;
    }

    async showVat(vat_id) {
        const response = await axios.get(BASE_URI + '/v1/central/vat/'+vat_id, config);
        return response;
    }

    async updateVat(data,vat_id) {
        const response = await axios.put(BASE_URI + '/v1/central/vat/'+vat_id, data,config);
        return response;
    }

    async deleteVat(vat_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/vat/'+vat_id,config);
        return response;
    }
}

class TimeZone {
    async getTimeZone(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/timezone'+queryString, config);
        return response;
    }

    async addTimeZone(data) {
        const response = await axios.post(BASE_URI + '/v1/central/timezone', data, config);
        return response;
    }

    async showTimeZone(timezone_id) {
        const response = await axios.get(BASE_URI + '/v1/central/timezone/'+timezone_id, config);
        return response;
    }

    async updateTimeZone(data,timezone_id) {
        const response = await axios.put(BASE_URI + '/v1/central/timezone/'+timezone_id, data,config);
        return response;
    }

    async deleteTimeZone(timezone_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/timezone/'+timezone_id,config);
        return response;
    }
}

class BuildingType {
    async getBuildingType(data) {
        const response = await axios.get(BASE_URI + '/v1/central/building-type'+data, config);
        return response;
    }

    async addBuildingType(data) {
        const response = await axios.post(BASE_URI + '/v1/central/building-type', data, config);
        return response;
    }

    async showBuildingType(data) {
        const response = await axios.get(BASE_URI + '/v1/central/building-type/'+data, config);
        return response;
    }

    async updateBuildingType(data, id) {
        const response = await axios.put(BASE_URI + '/v1/central/building-type/'+ id, data,config);
        return response;
    }

    async deleteBuildingType(data) {
        const response = await axios.delete(BASE_URI + '/v1/central/building-type/'+data,config);
        return response;
    }
}

class CustomerGroup {
    async getCustomerGroup(data) {
        const response = await axios.get(BASE_URI + '/v1/central/customer-group'+data, config);
        return response;
    }

    async addCustomerGroup(data) {
        const response = await axios.post(BASE_URI + '/v1/central/customer-group', data, config);
        return response;
    }

    async showCustomerGroup(data) {
        const response = await axios.get(BASE_URI + '/v1/central/customer-group/'+data, config);
        return response;
    }

    async updateCustomerGroup(data, id) {
        const response = await axios.put(BASE_URI + '/v1/central/customer-group/'+ id, data,config);
        return response;
    }

    async deleteCustomerGroup(data) {
        const response = await axios.delete(BASE_URI + '/v1/central/customer-group/'+data,config);
        return response;
    }
}

class Currency {
    async getCurrency(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/currency'+queryString, config);
        return response;
    }

    async addCurrency(data) {
        const response = await axios.post(BASE_URI + '/v1/central/currency', data, config);
        return response;
    }

    async showCurrency(currency_id) {
        const response = await axios.get(BASE_URI + '/v1/central/currency/'+currency_id, config);
        return response;
    }

    async updateCurrency(data,currency_id) {
        const response = await axios.put(BASE_URI + '/v1/central/currency/'+currency_id, data,config);
        return response;
    }

    async deleteCurrency(currency_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/currency/'+currency_id,config);
        return response;
    }
}

class IntegrationType {
    async getIntegrationType(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/integration-type'+queryString, config);
        return response;
    }

    async addIntegrationType(data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/integration-type', data, addConfig);
        return response;
    }

    async showIntegrationType(integrationtype_id) {
        const response = await axios.get(BASE_URI + '/v1/central/integration-type/'+integrationtype_id, config);
        return response;
    }

    async updateIntegrationType(data,integrationtype_id) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/integration-type/'+integrationtype_id, data,addConfig);
        return response;
    }

    async deleteIntegrationType(integrationtype_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/integration-type/'+integrationtype_id,config);
        return response;
    }
}

class Receipt {
    async getReceipt(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/receipt'+queryString, config);
        return response;
    }

    async addReceipt(data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/receipt', data, addConfig);
        return response;
    }

    async showReceipt(receipt_id) {
        const response = await axios.get(BASE_URI + '/v1/central/receipt/'+receipt_id, config);
        return response;
    }

    async updateReceipt(data,receipt_id) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/receipt/'+receipt_id, data,addConfig);
        return response;
    }
}

class ReceiptsType {
    async getReceiptType(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/receipts-type'+queryString, config);
        return response;
    }
}

class TaxInvoice {
    async getTaxInvoice(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/tax-invoice'+queryString, config);
        return response;
    }

    async addTaxInvoice(data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/tax-invoice', data, addConfig);
        return response;
    }

    async showTaxInvoice(taxInvoiceId) {
        const response = await axios.get(BASE_URI + '/v1/central/tax-invoice/'+taxInvoiceId, config);
        return response;
    }

    async updateTaxInvoice(data,taxInvoiceId) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/tax-invoice/'+taxInvoiceId, data,addConfig);
        return response;
    }

}

class TaxInvoiceType {
    async getTaxInvoiceType(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/tax-invoice-type'+queryString, config);
        return response;
    }
}

class Label {
    async getLabel(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/label'+queryString, config);
        return response;
    }

    async addLabel(data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/label', data, addConfig);
        return response;
    }

    async showLabel(label_id) {
        const response = await axios.get(BASE_URI + '/v1/central/label/'+label_id, config);
        return response;
    }

    async updateLabel(data,label_id) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/label/'+label_id, data,addConfig);
        return response;
    }

    async deleteLabel(label_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/label/'+label_id,config);
        return response;
    }
}

class Delivery {
    async getDelivery(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/delivery'+queryString, config);
        return response;
    }

    async addDelivery(data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/delivery', data, addConfig);
        return response;
    }

    async showDelivery(delivery_id) {
        const response = await axios.get(BASE_URI + '/v1/central/delivery/'+delivery_id, config);
        return response;
    }

    async updateDelivery(data,delivery_id) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/delivery/'+delivery_id, data,addConfig);
        return response;
    }
}
class DeliverysType {
    async getDeliveryType(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/delivery-type'+queryString, config);
        return response;
    }
}
class Language {
    async getLanguage(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/language'+queryString, config);
        return response;
    }

    async addLanguage(data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/language', data, addConfig);
        return response;
    }

    async showLanguage(language_id) {
        const response = await axios.get(BASE_URI + '/v1/central/language/'+language_id, config);
        return response;
    }

    async updateLanguage(data,language_id) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.put(BASE_URI + '/v1/central/language/'+language_id, data,addConfig);
        return response;
    }

    async deleteLanguage(language_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/language/'+language_id,config);
        return response;
    }
}
class Store {
    async getStore(query) {
        const response = await axios.get(BASE_URI + '/v1/central/tenant'+query, config);
        return response;
    }
    async showStore(store_id, query) {
        const response = await axios.get(BASE_URI + '/v1/central/tenant/'+store_id+query, config);
        return response;
    }

    async updateStorel(store_id, data) {
        const response = await axios.put(BASE_URI + '/v1/tenants/'+store_id, data, config);
        return response;
    }

    async updateRestore(store_id, data) {
        const response = await axios.put(BASE_URI + '/v1/tenants/'+store_id+ '/restoretenant', data, config);
        return response;
    }

    async updateArchiveStore(store_id, data) {
        const response = await axios.put(BASE_URI + '/v1/tenants/'+store_id+ '/archivestoretenant', data, config);
        return response;
    }

    // F00034 Tenant Auto Archive — ยกเว้นร้านจาก auto-archive แบบ case-by-case
    // (แทน Nova Exempt action ที่ไม่ได้ทำ เพราะตกลงกันว่าจะไม่แตะ Nova)
    async setAutoArchiveExempt(store_id, enabled) {
        const response = await axios.put(BASE_URI + '/v1/auto-archive/exempt/' + store_id, { enabled }, config);
        return response;
    }

    async getStoreNoteMedia(store_id) {
        return await axios.get(BASE_URI + '/v1/central/tenant/'+store_id+'/getNoteMedia', config);
    }

    async postAddNote(store_id, data) {
        return await axios.post(BASE_URI + '/v1/central/tenant/'+store_id+'/addnote', data, config);
    }

    async putUpdateNote(store_id, data) {
        return await axios.post(BASE_URI + '/v1/central/tenant/'+store_id+'/updatenote', data, config);
    }

    async deleteNote(note_id) {
        return await axios.delete(BASE_URI + '/v1/central/tenant-note/'+note_id, config);
    }

    async getStoreLog(store_id, query) {
        return await axios.get(BASE_URI + '/v1/central/tenant/'+store_id+'/getlog'+query, config);
    }

    async getIntegrationType(store_id,queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/tenant/'+store_id+'/integration'+queryString, config);
        return response;
    }

    async updateIntegrationType(store_id,data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/tenant/'+store_id+'/integration', data,addConfig);
        return response;
    }
    
    async getStaff(query) {
        return await axios.get(BASE_URI + '/v1/central/tenant/getstaff'+query, config);
    }

    async getStaffs(query) {
        try {
            return await axios.get(BASE_URI + '/v1/central/tenant/getstaffs'+query, config);
        } catch (err) {
            return err.response;
        }
    }

    async postAddStaff(store_id, data) {
        return await axios.post(BASE_URI + '/v1/central/tenant/'+store_id+'/addstaff', data, config);
    }

    async deleteStaff(staff_id) {
        return await axios.delete(BASE_URI + '/v1/central/tenant-staff/'+staff_id, config);
    }

    async postAddTag(store_id, data) {
        return await axios.post(BASE_URI + '/v1/central/tenant/'+store_id+'/addtag', data, config);
    }
    
    async deleteTag(tag_id) {
        return await axios.delete(BASE_URI + '/v1/central/tenant-tag/'+tag_id, config);
    }
}

class Wallet {
    async addCredit(tenantID, data) {
        return await axios.post(BASE_URI + '/v1/central/merchant/'+tenantID+'/wallet/addcredit', data, config);
    }

    async getBillingTransection(tenantID, queryString) {
        return await axios.get(BASE_URI + '/v1/central/merchant/'+tenantID+'/wallet/transaction/billing' + queryString, config);
    }

    async getWalletShipmentTransaction(tenantID, queryString) {
        return await axios.get(BASE_URI + '/v1/central/merchant/'+tenantID+'/wallet/transaction/walletShipmentTransaction' + queryString, config);
    }
}

class Promotion {
    async getPromotion() {
        return await axios.get(BASE_URI + '/v1/central/promotion', config);
    }
}

class TenantPromotion {
    async addTenantPromotion(data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };
        return await axios.post(BASE_URI + '/v1/central/tenant-promotion', data, addConfig);
    }
}


class User {
    async addSecondaryEmail(user_id, data) {
        return await axios.post(BASE_URI + '/v1/central/user/'+ user_id +'/addsecondaryemail', data, config);
    }

    async getUser(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/user'+queryString, config);
        return response;
    }

    async addUser(data) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/user', data, addConfig);
        return response;
    }

    async showUser(user_id) {
        const response = await axios.get(BASE_URI + '/v1/central/user/'+user_id, config);
        return response;
    }

    async updateUser(data,user_id) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/user/'+user_id, data,addConfig);
        return response;
    }

    async deleteUser(user_id) {
        const response = await axios.delete(BASE_URI + '/v1/central/user/'+user_id,config);
        return response;
    }

    async addBookmark(data) {
        const response = await axios.put(BASE_URI + '/v1/central/user', data, config);
        return response;
    }

    async updateStoreLimit(data,customer_id) {
        let addConfig = config;
        addConfig['header'] = {
            'Content-Type': 'multipart/form-data'
        };

        const response = await axios.post(BASE_URI + '/v1/central/user/'+customer_id + '/updateStoreLimit', data, addConfig);
        return response;
    }

    async getStoreLimit(customer_id) {
        const response = await axios.get(BASE_URI + '/v1/central/user/'+customer_id+'/getStoreLimit', config);
        return response;
    }


}

class WhiteLabel {
    async getWhiteLabel(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/white-label'+queryString, config);
        return response;
    }
}

class Role {
    async getRole(queryString) {
        const response = await axios.get(BASE_URI + '/v1/central/roles'+queryString, config);
        return response;
    }
}

class Validate{
    async isUniquePhoneNumber(data) {
        return await axios.get(BASE_URI + '/v1/auth/phone/registered/' + data, config);
    }
    
    async isEmailValid(data) {
        return await axios.get(BASE_URI + '/v1/auth/email/emailvalid/' + data, config);
    }
}

class Plan {
    async subscription(id, slug) {
        return await axios.post(BASE_URI + `/v1/central/tenant/${id}/subscription`, {plan_slug: slug}, config);
    }
    async getPlansSeries(queryString = '') {
        return await axios.get(BASE_URI + '/v1/central/plan/planseries' + queryString, config);
    }
    async getPlan(queryString = '') {
        return await axios.get(BASE_URI + '/v1/central/plan' + queryString, config);
    }  
    async listPlan(queryString = '') {
        return await axios.get(BASE_URI + '/v1/central/plan/list' + queryString, config);
    } 
}

class Import {
    async importXcom(apiKey, tenantId, importTypeId, integration = '') {
        return await axios.get(BASE_URI + `/v1/central/tenant/importXcom/${apiKey}/${tenantId}/${importTypeId}` + integration, config);
    }

    async countImportXcom(tenantId, importTypeId){
        return await axios.get(BASE_URI + `/v1/central/tenant/importXcom/countImportXcom/${tenantId}/${importTypeId}`, config);
    }

    async getImportType(tenantId, queryString = ''){
        return await axios.get(BASE_URI + `/v1/central/tenant/importXcom/getImportType/${tenantId}` + queryString, config);
    }

}


class Integration {
    async getIntegration(queryString) {
        // const response = await axios.get(BASE_URI + '/v1/central/integration-type'+queryString, config);
        const response = await axios.get(BASE_URI + '/v1/central/integration-type/integration-list'+queryString, config);
        return response;
    }
}
class ImportV2 {
    async getImport(queryString = '') {
        try{
            const response = await axios.get(BASE_URI + '/v2/import/xcom' + signature(queryString), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }

    async postImport(data = []) {
        try{
            const response = await axios.post(BASE_URI + '/v2/import/xcom/create' + signature(), data, config);
            return response;
        } catch (err) { 
            console.log('err.response = ',err.response);
            return err.response;
        }
    }

    async getImportCreate(queryString = '') {
        try{
            const response = await axios.get(BASE_URI + '/v2/import/xcom/create' + signature(queryString), config);
            return response;
        } catch (err) { 
            console.log('err.response = ',err.response);
            return err.response;
        }
    }
    
    async getImportRetry(id = null, data = null) {
        try{
            const response = await axios.put(BASE_URI + '/v2/import/xcom/' + id + '/retry' + signature(), data, config); 
            return response;
        } catch (err) { 
            console.log('err.response = ',err.response);
            return err.response;
        }
    }

    async cancelImport(id = null, data = null) {
        try{
            const response = await axios.put(BASE_URI + '/v2/import/xcom/' + id + '/cancel' + signature(), data, config); 
            return response;
        } catch (err) { 
            console.log('err.response = ',err.response);
            return err.response;
        }
    }
    
    async postImportBuyer(data = []){
        const response = await axios.post(BASE_URI + '/v2/import/buyer/create' + signature(), data, config);
        return response;
    }

    async getImportBuyer(queryString = ''){
        const response = await axios.get(BASE_URI + '/v2/import/buyer/create' + signature(queryString), config);
        return response;
    }

    async getListImportBuyer(queryString = ''){
        const response = await axios.get(BASE_URI + '/v2/import/buyer' + signature(queryString), config);
        return response;
    }

    async getListManualBuyer(queryString = ''){
        const response = await axios.get(BASE_URI + '/v2/import/buyer/manual' + signature(queryString), config);
        return response;
    }

    async getEditManualBuyer(id, queryString = ''){
        const response = await axios.get(BASE_URI + '/v2/import/buyer/manual/'+ id +'/edit' + signature(queryString), config);
        return response;
    }

    async putEditManualBuyer(id, data){
        const response = await axios.put(BASE_URI + '/v2/import/buyer/manual/'+ id + signature(), data, config);
        return response;
    }
}
class PlanGroup {
    async get() {
        try {
            return await axios.get(BASE_URI + '/v1/central/plan-group', config);
        } catch (err) {
            return err.response;
        }
    }
}

class Announcement {
    async createAnnouncement(data) {
        return await axios.post(BASE_URI + '/v1/central/announcement', data, config);
    }

    async getAllAnnouncement(queryString) {
        return await axios.get(BASE_URI + '/v1/central/announcement' + queryString, config);
    }

    async getAnnouncement(id) {
        return await axios.get(BASE_URI + '/v1/central/announcement/' + id, config);
    }

    async updateAnnouncement(id, data) {
        return await axios.put(BASE_URI + '/v1/central/announcement/' + id, data, config);
    }

    async getAnnouncementType(queryString = '') {
        return await axios.get(BASE_URI + '/v1/central/announcement/type' + queryString, config);
    }
}

class Billing {

    async getOrder(queryString = '') {
        return await axios.get(BASE_URI + '/v1/central/billing' + queryString, config);
    }
    
    async getOrderById(id) {
        return await axios.get(BASE_URI + '/v1/central/billing/' + id, config);
    }

    async approveOrder(id) {
        return await axios.post(BASE_URI + '/v1/central/billing/'+ id + '/approve', "", config);
    }

    async rejectOrder(id) {
        return await axios.post(BASE_URI + '/v1/central/billing/'+ id + '/reject', "", config);
    }

    async addPayment(id,data) {
        return await axios.post(BASE_URI + '/v1/central/billing/'+ id + '/addPayment', data, config);
    }

    async addNote(id,data) {
        return await axios.post(BASE_URI + '/v1/central/billing/'+ id +'/addNote', data, config);
    }

    async updateNote(id,data) {
        return await axios.post(BASE_URI + '/v1/central/billing/'+ id +'/updateNote', data, config);
    }

    async deleteNote(id,data) {
        return await axios.post(BASE_URI + '/v1/central/billing/'+ id +'/deleteNote', data, config);
    }

    async addTag(id,data) {
        return await axios.post(BASE_URI + '/v1/central/billing/'+ id +'/addTag', data, config);
    }

    async deleteTag(id,data) {
        return await axios.post(BASE_URI + '/v1/central/billing/'+ id +'/deleteTag', data, config);
    }
}

class Leads {

    async getLeads(queryString = '') {
        return await axios.get(BASE_URI + '/v2/lead' + signature(queryString), config);
    }
    
    async postCreateLeads(data) {
        return await axios.post(BASE_URI + '/v2/lead/create'+ signature() , data, config);
    }

    async getCreateLeads(queryString) {
        return await axios.get(BASE_URI + '/v2/lead/create' + signature() , config);
    }

    async getEditLeads(id ,queryString = '') {
        return await axios.get(BASE_URI + '/v2/lead/' + id + '/edit' + signature(), config);
    }

    async putEditLeads(id ,data) {
        return await axios.put(BASE_URI + '/v2/lead/' + id + '/edit' + signature(), data, config);
    }

    async getInfoLeads(id){
        return await axios.get(BASE_URI + '/v2/lead/' + id + signature(), config);
    }

    async getStaffLeads(id,queryString = ''){
        return await axios.get(BASE_URI + '/v2/lead/' + id + '/staffs' + signature(queryString), config);
    }

    async postStaffLeads(id,data){
        return await axios.post(BASE_URI + '/v2/lead/' + id + '/staffs' + signature() ,data ,config);
    }

    async deleteStaffLeads(id,staff_id){
        return await axios.delete(BASE_URI + '/v2/lead/' + id + '/staffs/'+ staff_id + signature() ,config);
    }

    async postTagsLeads(id,data){
        return await axios.post(BASE_URI + '/v2/lead/' + id + '/tags' + signature() ,data ,config);
    }

    async deleteTagsLeads(id,tag_id){
        return await axios.delete(BASE_URI + '/v2/lead/' + id + '/tags/' + tag_id + signature() ,config);
    }

    async postNoteLeads(id,data){
        return await axios.post(BASE_URI + '/v2/lead/' + id + '/notes' + signature() ,data ,config);
    }

    async postAppointmentLeads(id,data){
        return await axios.post(BASE_URI + '/v2/lead/' + id + '/appointments' + signature() ,data ,config);
    }

    async getLogLeads(id,queryString = ''){
        return await axios.get(BASE_URI + '/v2/lead/' + id + '/logs' + signature(), config);
    }

    async getAppointmentsLeads(id,queryString = ''){
        return await axios.get(BASE_URI + '/v2/lead/' + id + '/appointments' + signature(queryString), config);
    }

    async getNotesLeads(id,queryString = ''){
        return await axios.get(BASE_URI + '/v2/lead/' + id + '/notes' + signature(queryString), config);
    }

    async getAttachmentsLeads(id,queryString = ''){
        return await axios.get(BASE_URI + '/v2/lead/' + id + '/attachments' + signature(queryString), config);
    }

    async deleteAppointmentsLeads(id,appointments_id){
        return await axios.delete(BASE_URI + '/v2/lead/' + id + '/appointments/' + appointments_id + signature() ,config);
    }

    async deleteNotesLeads(id,note_id){
        return await axios.delete(BASE_URI + '/v2/lead/' + id + '/notes/' + note_id + signature() ,config);
    }

    async deleteAttachmentsLeads(id,data){
        return await axios.put(BASE_URI + '/v2/lead/' + id + '/attachments' + signature(),data ,config);
    }

    async editAppointmentsLeads(id,appointments_id){
        return await axios.get(BASE_URI + '/v2/lead/' + id + '/appointments/' + appointments_id + '/edit' + signature() ,config);
    }

    async editNotesLeads(id,note_id){
        return await axios.get(BASE_URI + '/v2/lead/' + id + '/notes/' + note_id + '/edit' + signature() ,config);
    }

    async putAttachmentsLeads(id,appointments_id,data){
        return await axios.put(BASE_URI + '/v2/lead/' + id + '/appointments/'+ appointments_id + '/edit' + signature(),data ,config);
    }

    async putNotesLeads(id,note_id,data){
        return await axios.put(BASE_URI + '/v2/lead/' + id + '/notes/'+ note_id + '/edit' + signature(),data ,config);
    }
}

class SalesOrderV2 {
    async approve(id) {
        return await axios.post(BASE_URI + '/v2/order/'+ id + '/approve' + signature(), "", config);
    }
}

class TenantV2 {
    async subscription(id, data) {
        return await axios.post(BASE_URI + '/v2/tenants/'+ id + '/subscription' + signature(), data, config);
    }

    async getTenantInfo(id) {
        try{
            const response = await axios.get(BASE_URI + '/v2/tenants/' + id  + signature(), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }

    async postTenantSettingById(id = null,data = {}) {
        try{
            const response = await axios.post(BASE_URI + '/v2/tenants/' + id + '/imports/auth' + signature(),data, config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
}

class Report{
    async getReport(querystring) {
        return await axios.get(BASE_URI + '/v1/central/reports/export-log' + querystring, config);
    }
}

class TagManagement {

    async getTagManagement(queryString) {
        try{
            const response = await axios.get(BASE_URI + '/v2/tag' + signature(queryString), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    
    async getTagCreate() {
        try{
            const response = await axios.get(BASE_URI + '/v2/tag/create' + signature(), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    
    async postTagCreate(data = {}) {
        try{
            const response = await axios.post(BASE_URI + '/v2/tag' + signature(), data, config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    
    async getTagEdit(id) {
        try{
            const response = await axios.get(BASE_URI + '/v2/tag/' + id + '/edit' + signature(), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    
    async putTagEdit(id,data) {
        try{
            const response = await axios.put(BASE_URI + '/v2/tag/' + id + signature(), data, config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    
    async deleteTag(id) {
        try{
            const response = await axios.delete(BASE_URI + '/v2/tag/' + id + signature(), config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
}


class Export {
    async getExport(querystring) {
        return await axios.get(BASE_URI + '/v1/central/export' + querystring, config);
    }
    async creatExport(data) {
        try{
            const response = await axios.post(BASE_URI + '/v1/central/export', data, config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
    async getExportDetail(id) {
        return await axios.get(BASE_URI + `/v1/central/export/${id}/info`, config);
    }
    async getExportLog(id, querystring) {
        return await axios.get(BASE_URI + `/v1/central/export/${id}/activity` + querystring, config);
    }
    async postDownloadFileLog(id, index) {
        return await axios.post(BASE_URI + `/v1/central/export/${id}/${index}/download`, {}, config);
    }
}
class EmailBlacklist {
    async getEmailBlacklist(queryString) {
        const response = await axios.get(BASE_URI + '/v1/auth/email/blacklist/list'+queryString, config);
        return response;
    }

    async addEmailBlacklist(data) {
        const response = await axios.post(BASE_URI + '/v1/auth/email/blacklist/create', data, config);
        return response;
    }

    async showEmailBlacklist(id) {
        const response = await axios.get(BASE_URI + '/v1/auth/email/blacklist/detail/'+id, config);
        return response;
    }

    async updateEmailBlacklist(data,id) {
        const response = await axios.put(BASE_URI + '/v1/auth/email/blacklist/detail/'+id, data,config);
        return response;
    }

    async deleteEmailBlacklist(id) {
        const response = await axios.delete(BASE_URI + '/v1/auth/email/blacklist/detail/'+id,config);
        return response;
    }
}

class EmailWhitelist {
    async getEmailWhitelist(queryString) {
        const response = await axios.get(BASE_URI + '/v1/auth/email/whitelist/list'+queryString, config);
        return response;
    }

    async addEmailWhitelist(data) {
        const response = await axios.post(BASE_URI + '/v1/auth/email/whitelist/create', data, config);
        return response;
    }

    async showEmailWhitelist(id) {
        const response = await axios.get(BASE_URI + '/v1/auth/email/whitelist/detail/'+id, config);
        return response;
    }

    async updateEmailWhitelist(data,id) {
        const response = await axios.put(BASE_URI + '/v1/auth/email/whitelist/detail/'+id, data,config);
        return response;
    }

    async deleteEmailWhitelist(id) {
        const response = await axios.delete(BASE_URI + '/v1/auth/email/whitelist/detail/'+id,config);
        return response;
    }
}

class Tools {
    async postCheckUser(data = {}) {
        try {
            const response = await axios.post(BASE_URI + '/v1/auth/checklogin', data, config);
            return response;
        } catch (err) { 
            return err.response;
        }
    }
}

class UsageService {
    async getUsageServiceList(queryString = "") {
        try {
            const response = await axios.get(BASE_URI + '/v2/usages' + signature(queryString), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
    async getUsageServiceDetail(id) {
        try {
            const response = await axios.get(BASE_URI + '/v2/usages/'+ id + signature(), config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}

class Unmask {
    async unmask(data) {
        try {
            const response = await axios.post(BASE_URI + '/v2/unmask' + signature(), data, config);
            return response;
        } catch (err) {
            return err.response;
        }
    }
}

class CouponManagement {
    async getCoupons(queryString) {
        return await axios.get(BASE_URI + '/v1/central/coupon-management' + queryString, config);
    }
    async createCoupon(data) {
        return await axios.post(BASE_URI + '/v1/central/coupon-management', data, config);
    }
    async showCoupon(id) {
        return await axios.get(BASE_URI + '/v1/central/coupon-management/' + id, config);
    }
    async updateCoupon(data, id) {
        return await axios.put(BASE_URI + '/v1/central/coupon-management/' + id, data, config);
    }
    async deleteCoupon(id) {
        return await axios.delete(BASE_URI + '/v1/central/coupon-management/' + id, config);
    }
    async searchCoupons(q) {
        return await axios.get(BASE_URI + '/v1/central/coupon-management/search?q=' + q, config);
    }
    async getStats() {
        return await axios.get(BASE_URI + '/v1/central/coupon-management/stats', config);
    }
    async getTypes() {
        return await axios.get(BASE_URI + '/v1/central/coupon-management/types', config);
    }
    async exportCoupons(queryString) {
        return await axios.get(BASE_URI + '/v1/central/coupon-management/export' + queryString, { ...config, responseType: 'blob' });
    }
    async validateOwner(globalId) {
        return await axios.get(BASE_URI + '/v1/central/coupon-management/validate-owner?global_id=' + globalId, config);
    }
    async getPromotions() {
        return await axios.get(BASE_URI + '/v1/central/promotion-management?per_page=100&status=1', config);
    }
}

class PromotionManagement {
    async getPromotions(queryString) {
        return await axios.get(BASE_URI + '/v1/central/promotion-management' + queryString, config);
    }
    async createPromotion(data) {
        return await axios.post(BASE_URI + '/v1/central/promotion-management', data, config);
    }
    async showPromotion(id) {
        return await axios.get(BASE_URI + '/v1/central/promotion-management/' + id, config);
    }
    async updatePromotion(data, id) {
        return await axios.put(BASE_URI + '/v1/central/promotion-management/' + id, data, config);
    }
    async deletePromotion(id) {
        return await axios.delete(BASE_URI + '/v1/central/promotion-management/' + id, config);
    }
    async getRules() {
        return await axios.get(BASE_URI + '/v1/central/promotion-management/rules', config);
    }
    async getTypes() {
        return await axios.get(BASE_URI + '/v1/central/promotion-management/types', config);
    }
    async getGroups() {
        return await axios.get(BASE_URI + '/v1/central/promotion-management/groups', config);
    }
}

class MonthlyGeneration {
    async preview(formData) {
        return await axios.post(BASE_URI + '/v1/central/monthly-generation/preview', formData, {
            ...config,
            headers: { ...config.headers, 'Content-Type': 'multipart/form-data' }
        });
    }
    async confirm(data) {
        return await axios.post(BASE_URI + '/v1/central/monthly-generation/confirm', data, config);
    }
    async checkDuplicate(month, year) {
        return await axios.get(BASE_URI + '/v1/central/monthly-generation/check-duplicate?month=' + month + '&year=' + year, config);
    }
    async getHistory(queryString) {
        return await axios.get(BASE_URI + '/v1/central/monthly-generation/history' + queryString, config);
    }
}

export default {
    Signature: new Signature(),
    AUTH: {
        URL: BASE_URI,
        TOKEN: ACCESS_TOKEN.token
    },
    Signature: new Signature(),
    URL: {
        TAG: API_TAG,
        LEADS: API_LEADS,
        CUSTOMERS: API_CUSTOMERS,
        SETTING_GETUSER: API_SETTING_GETUSER,
        STAFF_SEARCH,
        COUPONOWNER_SEARCH,
        IMPORT_XCOM_TENANST,
        COUPON_SEARCH,
        STORE_SEARCH,
        BUYER_STORE_SEARCH,
        CUSTOMER_V2_TAG,
        CUSTOMER_V2_REFER,
    },
    Plan: new Plan(),
    Auth: new Auth(),
    Invitation: new Invitation(),
    Address: new Address(),
    Email: new Email(),
    Password: new Password(),
    Tenant: new Tenant(),
    Domain: new Domain(),
    Country: new Country(),
    Industry: new Industry(),
    Customer: new Customer(),
    CustomerV2: new CustomerV2(),
    User: new User(),
    Gender: new Gender(),
    CustomerType: new CustomerType(),
    Bank: new Bank(),
    ShippingType: new ShippingType(),
    SocialCodeType: new SocialCodeType(),
    PaymentMethod: new PaymentMethod(),
    VatMethod: new VatMethod(),
    Unit: new Unit(),
    ProductType: new ProductType(),
    SalePageType: new SalePageType(),
    LabelType: new LabelType(),
    ReceiptsType: new ReceiptsType(),
    IntegrationGroup: new IntegrationGroup(),
    Module: new Module(),
    LocationType: new LocationType(),
    Font: new Font(),
    Vat: new Vat(),
    TimeZone: new TimeZone(),
    BuildingType: new BuildingType(),
    CustomerGroup: new CustomerGroup(),
    Currency: new Currency(),
    IntegrationType: new IntegrationType(),
    Receipt: new Receipt(),
    TaxInvoice: new TaxInvoice(),
    TaxInvoiceType: new TaxInvoiceType(),
    DeliverysType: new DeliverysType(),
    Delivery: new Delivery(),
    Label: new Label(),
    Language: new Language(),
    Store: new Store(),
    Wallet: new Wallet(),
    Promotion: new Promotion(),
    TenantPromotion: new TenantPromotion(),
    WhiteLabel:new WhiteLabel(),
    Validate:new Validate(),
    Role: new Role(),
    Import: new Import(),
    ImportV2: new ImportV2(),
    Export: new Export(),
    Integration: new Integration(),
    PlanGroup: new PlanGroup(),
    Billing: new Billing(),
    SalesOrderV2: new SalesOrderV2(),
    TenantV2: new TenantV2(),
    Announcement: new Announcement(),
    ACCESS_TOKEN: ACCESS_TOKEN.token,
    Leads: new Leads(),
    Report: new Report(),
    TagManagement: new TagManagement(),
    EmailBlacklist: new EmailBlacklist(),
    EmailWhitelist: new EmailWhitelist(),
    Tools: new Tools(),
    UsageService: new UsageService(),
    CouponManagement: new CouponManagement(),
    PromotionManagement: new PromotionManagement(),
    MonthlyGeneration: new MonthlyGeneration(),
    Unmask: new Unmask(),
}



// WEBPACK FOOTER //
// ./src/services/endpoint/api.service.js